// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Np-z","breadcrumbForward":"Op-z","breadcrumbBack":"Pp-z","selected":"Qp-z"};